__turbopack_context__.v({
  "radio": "_4eufyW_radio",
  "radio__input": "_4eufyW_radio__input",
  "radio__label": "_4eufyW_radio__label",
});
